import LoadingComponent from './src/Loading.vue'
import { createVNode, render } from 'vue'

const container = document.createElement('div')
container.style.zIndex = 1
const vn = createVNode(LoadingComponent)
render(vn, container)
document.body.appendChild(container)

const loading = {
    start: () => {
        vn.component.proxy.show();
    },
    finish: () => {
        vn.component.proxy.hide()
    }
}

const confirm = {
    install(app) {
        app.config.globalProperties.$loading = loading
    }
}

export default confirm